import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({
    name: 'CountryListTools',
    components: {
        CardHeader
    }
})
export default class CountryListTools extends Vue {
    filter: string = '';

    private cleareFilter() {
        this.filter = ''
    }

    @Watch('filter')
    private searchCountry() {
        this.$emit('filtered', this.filter);
    }
}
